import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Form, Button, FormGroup, Input, Label } from 'reactstrap';

import userService from './user/UserService';

const Profile = () => {
  const history = useHistory();

  const [preferredActivities, setPreferredActivities] = useState([]);
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');

  const selectedActivityChanged = (id, checked) => {
    const newActivities = preferredActivities.map(activity => {
      let { preferredActivityId } = activity;
      if (preferredActivityId === id) activity.selected = checked;
      return activity;
    });

    setPreferredActivities(newActivities);
  }

  const saveProfile = async () => {
    await userService.updateProfile({
      firstName,
      lastName,
      preferredActivities: preferredActivities.filter(activity => activity?.selected)
    });
    history.push('/');
  };

  const fetchData = async () => {
    const [activities, userProfile] = await Promise.all([userService.getAvailableActivities(), userService.getProfile()]);
    // todo - sort this out
    // eric: what this is doing is comparing all available activities to the one the user has previously selected as his "preferred" activities.
    // essentially we want all items in values[0] with a new property "selected" that is true if the activity ID matches an item in values[1].
    const newPreferredActivities = activities.map(activity => ({ 
      ...activity, 
      selected: userProfile
        ?.preferredActivities
        ?.find(p => p.preferredActivityId === activity.preferredActivityId) !== null 
    }));

    setFirstName(userProfile?.firstName ?? '');
    setLastName(userProfile?.lastName ?? '');
    setPreferredActivities(newPreferredActivities);
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <Form>
      <legend>Personal Information</legend>
      <FormGroup>
        <Label>First Name</Label>
        <Input value={firstName} onChange={e => setFirstName(e.target?.value)} />
      </FormGroup>
      <FormGroup>
        <Label>Last Name</Label>
        <Input value={lastName} onChange={e => setLastName(e.target?.value)} />
      </FormGroup>
      <FormGroup>
        <legend>Preferred Regulation Activites</legend>
        {preferredActivities.map(({ name: activityName, preferredActivityId, selected }, i) => (
          <FormGroup check key={activityName}>
            <Input 
              id={`preferredCheck${i}`} 
              type="checkbox" 
              onChange={(e) => selectedActivityChanged(preferredActivityId, !!e?.target?.checked)} 
              checked={selected} 
            />
            <Label check for={`preferredCheck${i}`}>{activityName}</Label>
          </FormGroup>
        ))}
      </FormGroup>
      <FormGroup row style={{ justifyContent:'center' }}>
        <Button 
          color="primary" 
          style={{ width: '20%' }} 
          onClick={saveProfile}
        >
          Submit
        </Button>
      </FormGroup>
    </Form>
  );
}

export default Profile;